module.exports = __webpack_public_path__ + "static/media/back-icon.9089344d.svg";